import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mdiClose } from '@mdi/js';
import { Icon } from '@mdi/react';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { useMemo } from 'react';
// noinspection ES6PreferShortImport "Use direct import to avoid circular dependency"
import { useSTColumns, useSTColumnOrder } from '../../table/SmartTableContext';
import { defineStyles } from '../../theme';
import { ColumnsSettingsDialogRow } from './ColumnsSettingsDialogRow';
const styles = defineStyles({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    dialogActionsBox: {
        px: 3,
    },
    rightButton: {
        mr: 'auto',
    },
});
export function ColumnsSettingsDialog({ onClose, open }) {
    const { allColumns, setAllColumnsVisible, setAllColumnsHidden } = useSTColumns();
    const { shiftColumns, resetColumnOrder } = useSTColumnOrder();
    const columns = useMemo(() => allColumns.filter((column) => !column.isFilterOnly), [allColumns]);
    return (_jsxs(Dialog, { open: open, maxWidth: "sm", fullWidth: true, onClose: onClose, children: [_jsxs(DialogTitle, { sx: styles.header, children: [_jsx(FormattedMessage, { id: "tableColumnsFilterDialog.header", defaultMessage: "Column display" }), _jsx(ButtonBase, { onClick: onClose, disableRipple: true, children: _jsx(Icon, { path: mdiClose, size: 1 }) })] }), _jsx(DialogContent, { sx: styles.content, children: columns.map((column) => (_jsx(ColumnsSettingsDialogRow, { column: column }, column.fieldName))) }), _jsxs(DialogActions, { sx: styles.dialogActionsBox, children: [_jsx(Button, { variant: "outlined", onClick: setAllColumnsVisible, children: _jsx(FormattedMessage, { id: "tableColumnsFilterDialog.selectAll.button", defaultMessage: "Select All" }) }), _jsx(Button, { variant: "outlined", onClick: setAllColumnsHidden, children: _jsx(FormattedMessage, { id: "tableColumnsFilterDialog.deselectAll.button", defaultMessage: "Deselect All" }) }), _jsx(Button, { variant: "outlined", onClick: shiftColumns, children: _jsx(FormattedMessage, { id: "tableColumnsFilterDialog.shiftColumns.button", defaultMessage: "Shift" }) }), _jsx(Button, { variant: "outlined", onClick: resetColumnOrder, sx: styles.rightButton, children: _jsx(FormattedMessage, { id: "tableColumnsFilterDialog.resetColumns.button", defaultMessage: "Reset" }) }), _jsx(Button, { variant: "contained", onClick: onClose, children: _jsx(FormattedMessage, { id: "common.ok.button", defaultMessage: "OK" }) })] })] }));
}
//# sourceMappingURL=ColumnsSettingsDialog.js.map